module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_included_dress-6aa74c400f695218f2c4d87d565bb748.png";